import request from "../utils/request";

export async function getSupplierList(payload) {
  return request.get("Supplier/List", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      name: payload.supplier ? payload.supplier.name : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      email: payload.supplierEmail,
      phoneNumber: payload.supplierPhoneNumber,
      owner: payload.supplierOwner,
      bank: payload.supplierBank,
      bankAccount: payload.supplierBankAccount,
      address: payload.supplierAddress
    }
  });
}
export async function createNewSupplier(newSupplier) {
  return request.post("Supplier/Create", newSupplier);
}
export async function updateSupplier(supplier) {
  return request.post("Supplier/Update", supplier);
}
export async function deleteSupplier(id) {
  return request.delete('Supplier/Delete?id=' + id);
}
export async function getSupplierNameList() {
  return request.get("Supplier/NameList");
}
export async function getDistributorNameList(payload) {
  let query = serialize(payload);
  return request.get("Supplier/DistributorNameList?" + query);
}
export async function getSupplierNameSelectList() {
  return request.get("Supplier/SupplierNameSelectList");
}

function serialize(obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}
